import axios from "axios";
import { requiredParam } from "@utils/func";

const authenticateUser = ({
  email = requiredParam("email"),
  password = requiredParam("password"),
} = {}) => {
  return axios.post("/login", {
    username: email,
    password,
  });
};

export { authenticateUser };
